/**
 * Created by matei on 14/11/2019
 */

import React, { PureComponent } from 'react';
import { event } from 'react-ga';
import { withRouter } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';

import InputField from '../../components/inputfield';
import Heading from '../../components/heading';

import { authActionsFacade as authActions } from '../../actions/auth';

import getValidator from '../../lib/utils/validation';
import profileValidation from './profile.validation';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const submit = (push, values, dispatch) => {
  /*
    event({
      category: 'Authentication',
      action: 'Registration',
      label: values.cursuri,
    });
  */
  dispatch(authActions.updateProfile(values)).then((res) => {
    if (!res.error) {
      dispatch(authActions.getUserProfile()).then((res) => {
        if (!res.error) {
          push('/profile/success');
        }
      });
    }
  });
};

const headingLinks = [
  {
    link: '/',
    text: 'Acasa',
  },
  {
    link: `/profile`,
    text: `Profilul meu`,
  },
];

function mapStateToProps(state) {
  return {
    status: state.auth.status,
    payload: state.auth.payload,
    error: state.auth.error,
    initialValues: {
      email: state.auth?.user?.email,
      phone: state.auth?.user?.phone,
      name: state.auth?.user?.name,
      firstname: state.auth?.user?.firstname,
    },
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    actions: bindActionCreators(Object.assign({},
      authActions,
    ), dispatch),
  };
}

@withRouter
@connect(mapStateToProps, mapDispatchToProps)
@reduxForm({
  form: 'profileForm',
  asyncValidate: getValidator(profileValidation),
})
export default class ProfilePage extends PureComponent {
  constructor() {
    super();

    this.renderInput = this.renderInput.bind(this);
  }

  renderInput({ input, placeholder, icon, className, meta, type, error, multiline, disabled }) {
    const {
      autoComplete,
    } = this.props;

    const domOnlyProps = {};
    if (autoComplete) {
      domOnlyProps.autoComplete = autoComplete;
    }

    return (
      <InputField
        { ...domOnlyProps }
        { ...input }
        name={ input.name }
        placeholder={ placeholder }
        dynamicPlaceholder
        debounceTimeout={ 300 }
        error={ meta.error || error }
        touched={ meta.touched }
        className={ className }
        type={ type }
        multiline={ multiline }
        disabled={ disabled }
      />
    );
  }

  render() {
    const {
      handleSubmit,
      actions: {
        logout,
      },
      history: {
        push,
      },
    } = this.props;

    return (
      <div className="loginPage">
        <Heading title="Profilul Meu" links={ headingLinks } />

        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="contact-page-form">
                <h2>Profilul Meu</h2>
                <form onSubmit={ handleSubmit(submit.bind(this, push)) }>
                  <div className="row">

                    <div className="col-md-6 col-sm-12 col-xs-12">
                      <div className="single-input-field">
                        <Field
                          name="email"
                          type="email"
                          component={ this.renderInput }
                          placeholder="E-Mail"
                          className="form-element"
                          disabled
                        />
                      </div>
                    </div>

                    <div className="col-md-6 col-sm-12 col-xs-12">
                      <div className="single-input-field">
                        <Field
                          name="phone"
                          type="text"
                          component={ this.renderInput }
                          placeholder="Nr. Telefon"
                          className="form-element"
                        />
                      </div>
                    </div>

                    <div className="col-md-6 col-sm-12 col-xs-12">
                      <div className="single-input-field">
                        <Field
                          name="name"
                          type="text"
                          component={ this.renderInput }
                          placeholder="Nume"
                          className="form-element"
                        />
                      </div>
                    </div>

                    <div className="col-md-6 col-sm-12 col-xs-12">
                      <div className="single-input-field">
                        <Field
                          name="firstname"
                          type="text"
                          component={ this.renderInput }
                          placeholder="Prenume"
                          className="form-element"
                        />
                      </div>
                    </div>

                    <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="single-input-field">
                        <Field
                          name="password"
                          type="password"
                          component={ this.renderInput }
                          placeholder="Parola Curentă"
                          className="form-element"
                        />
                      </div>
                    </div>

                    <div className="single-input-fieldsbtn">
                      <input type="submit" value="Trimite" />
                    </div>
                  </div>
                </form>
                <div className="row">
                  <div className="single-input-fieldsbtn" onClick={ (e) => {
                    e.preventDefault();
                    logout();
                    push('/');
                  } }>
                    <input type="submit" value="Log Out" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
